import actions from '@/store/photoGallery/actions';

const photoGalleryModule = {
  state: () => ({
    folders: [],
    foldersByIds: [],
    images: [],
  }),
  mutations: {
    SET_FOLDERS(state, payload) {
      state.folders = payload;
    },
    SET_FOLDERS_BY_IDS(state, payload) {
      state.foldersByIds = payload;
    },
    SET_IMAGES(state, payload) {
      state.images = payload;
    },
  },
  actions,
  namespaced: true,
};

export default photoGalleryModule;
